"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Tooltip"));
var _Icon = _interopRequireDefault(require("@mulesoft/anypoint-icons/lib/Icon"));
var dateUtils = _interopRequireWildcard(require("../../utils/date"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var CalendarIcon = function CalendarIcon(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8 2a1 1 0 0 1 1 1v1h6V3a1 1 0 1 1 2 0v1h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2V3a1 1 0 0 1 1-1zM7 6H5v3.99h14V6h-2v1a1 1 0 1 1-2 0V6H9v1a1 1 0 0 1-2 0V6zm12 5.99H5V20h14v-8.01z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10 14H8a1 1 0 0 0-1 1v2a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1v-2a1 1 0 0 0-1-1z"
  }));
};
CalendarIcon.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
var styles = {
  "publish-information": "PublishInformation__publish-information__1K-y_",
  "publishInformation": "PublishInformation__publish-information__1K-y_",
  "icon": "PublishInformation__icon__xmlb8"
}; 
require('./PublishInformation.css');
var format = {
  year: 'numeric',
  month: 'long',
  day: 'numeric',
  hour: 'numeric',
  minute: 'numeric'
};
var PublishInformation = function PublishInformation(_ref) {
  var publishingUser = _ref.publishingUser,
    publishingDate = _ref.publishingDate;
  return /*#__PURE__*/_react.default.createElement("div", {
    title: "Last published date",
    className: styles.publishInformation
  }, /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    content: dateUtils.formatDate(publishingDate, format)
  }, /*#__PURE__*/_react.default.createElement("div", {
    "data-test-id": "last-published-at"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    className: styles.icon,
    isDecorative: true,
    size: "xxs"
  }, /*#__PURE__*/_react.default.createElement(CalendarIcon, null)), publishingUser ? "".concat(publishingUser, " published ") : 'Published ', dateUtils.formatRelativeDate(publishingDate))));
};
var _default = exports.default = PublishInformation;
//# sourceMappingURL=PublishInformation.js.map